import { Box } from "@mui/material"

export default function Logo({ src }) {
    
    const { LOGO_FRAME } = window.conf.LAYOUT

    return (
        <Box 
            sx={{ 
                flexGrow: 0, 
                display: src ? { xs: 'none', sm: 'flex' } : "none"
            }}
        >
            <div style={{ 
                backgroundColor: src && LOGO_FRAME ? 'white' : 'transparent', 
                padding: 4,
                display: 'flex'
            }}> 
                <img
                    src={src}
                    alt='logo'
                    height='32px'
                />
            </div>
        </Box>
    )
}